import D1 from '../../components/ExcerciseTypes/Design/TypeIn';

const json = {

  1: { // Exercise num
    unit: 'Unit 5',
    id: 'WB3-U5-P35-E1',
    audio: '',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page35/E1/Key/answerKey.png',
    component: D1,
    //recorder: true,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page35/E1/1.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page35/E1/2.jpg' },
        { url: 'img/FriendsPlus/Page35/E1/3.jpg', input: true, answer: "don't like" },
        { url: 'img/FriendsPlus/Page35/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page35/E1/5.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page35/E1/6.jpg' },
        { url: 'img/FriendsPlus/Page35/E1/7.jpg', input: true, answer: "likes" },
        { url: 'img/FriendsPlus/Page35/E1/8.jpg' },
        { url: 'img/FriendsPlus/Page35/E1/9.jpg', input: true, answer: "doesn't like" },
        { url: 'img/FriendsPlus/Page35/E1/10.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page35/E1/11.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 5',
    id: 'WB3-U5-P35-E2',
    audio: 'img/FriendsPlus/Page35/Audio/audio-e2-p35.mp3',
    video: '',
    exerciseKey: 'img/FriendsPlus/Page35/E2/Key/answerKey.png',
    component: D1,
    isAllowSubmit: false,
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page35/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page35/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page35/Audio/tieude-e2-p35.mp3' },
        { url: 'img/FriendsPlus/Page35/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page35/E2/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page35/E2/5.jpg' },
        { url: 'img/FriendsPlus/Page35/E2/6.jpg', input: true, answer: "likes" },
        { url: 'img/FriendsPlus/Page35/E2/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page35/E2/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page35/E2/9.jpg' },
        { url: 'img/FriendsPlus/Page35/E2/10.jpg', input: true, answer: "like" },
        { url: 'img/FriendsPlus/Page35/E2/11.jpg' },
        { url: 'img/FriendsPlus/Page35/E2/12.jpg', input: true, answer: "doesn't like" },
        { url: 'img/FriendsPlus/Page35/E2/13.jpg' },
      ],
      [
        // Column6
        { url: 'img/FriendsPlus/Page35/E2/14.jpg' },
      ],


    ],
  },


}

export default json;